"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Progress;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = require("react");

var _ProgressModule = _interopRequireDefault(require("../../assets/styles/components/Progress.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Progress(_ref) {
  let {
    value,
    maxValue = 200,
    shape = "circular",
    label = true,
    isLoading = true,
    height = 100,
    width = 100,
    lineCap = "round",
    strokeWidth = 10
  } = _ref;
  //Type
  //Circular
  //Linear
  const [isLoading_state, setisLoading_state] = (0, _react.useState)(false);
  const [percentage_value, setpercentage_value] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    setisLoading_state(isLoading);

    if (isLoading === true) {
      setpercentage_value(.5);
    } else {
      setpercentage_value(0);
    }
  }, [isLoading]);
  (0, _react.useEffect)(() => {
    if (!isNaN(value) && value !== null) {
      setisLoading_state(false);
      setpercentage_value(100 / (maxValue / value) / 100);
    }
  }, [value, maxValue]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [shape === "circular" && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _ProgressModule.default.circular,
      style: {
        width: width + "px",
        height: height + "px"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _ProgressModule.default.outer,
        style: {
          width: width + "px",
          height: height + "px"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _ProgressModule.default.inner,
          style: {
            width: width - 40 + "px",
            height: height - 40 + "px"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _ProgressModule.default.number,
            children: label && !isLoading_state && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
              children: [Math.round(percentage_value * 100), "%"]
            })
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
        className: "".concat(isLoading_state && _ProgressModule.default.loading_svg),
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: width + "px",
        height: height + "px",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
            id: "GradientColor",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
              offset: "0%",
              stopColor: "#08678E"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
              offset: "100%",
              stopColor: "#08678E"
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
          cx: width / 2,
          cy: height / 2,
          r: width / 2 - 10,
          strokeLinecap: lineCap,
          strokeDashoffset: 2 * 3.14159265359 * (width / 2 - 10) * (1 - percentage_value),
          strokeDasharray: 2 * 3.14159265359 * (width / 2 - 10),
          strokeWidth: strokeWidth
        })]
      })]
    }), shape === "linear" && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _ProgressModule.default.linear,
      children: [label && !isLoading_state && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        style: {
          left: percentage_value * 100 + "%"
        },
        className: _ProgressModule.default.label,
        children: [Math.round(percentage_value * 100), "%"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _ProgressModule.default.bar,
        style: {
          height: strokeWidth + "px",
          borderRadius: lineCap === "square" ? "0px" : "10px"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            width: percentage_value * 100 + "%",
            borderRadius: lineCap === "square" ? "0px" : "10px"
          },
          className: "".concat(_ProgressModule.default.progress, " ").concat(isLoading_state && _ProgressModule.default.loading_bar)
        })
      })]
    })]
  });
}